// src/scripts/audits/auditScoring.js

/**
 * Shared audit scoring logic.
 *
 * Key rules:
 * - v keys = Venue Audit Score
 * - a keys = Admin Audit Score
 * - Answer "A" = pass / point scored
 * - Answer "B" = fail / no point
 * - null / undefined = unanswered / no point
 */

export function flattenAuditQuestions(sectionList = []) {
  return sectionList.flatMap((section) => section.items || []);
}

export function getAuditKeys(sectionList = []) {
  const questions = flattenAuditQuestions(sectionList);

  const allKeys = questions
    .map((question) => question.key)
    .filter(Boolean);

  return {
    allKeys,
    venueKeys: allKeys.filter((key) => String(key).startsWith("v")),
    adminKeys: allKeys.filter((key) => String(key).startsWith("a")),
  };
}

export function buildInitialAnswers(keys = []) {
  return keys.reduce((acc, key) => {
    acc[key] = null;
    return acc;
  }, {});
}

export function isAuditAnswerAnswered(answer) {
  return answer === "A" || answer === "B";
}

export function scorePercent(keys = [], answers = {}) {
  const total = keys.length;
  if (!total) return 0;

  let points = 0;

  for (const key of keys) {
    if (answers[key] === "A") {
      points += 1;
    }
  }

  return Math.round((points / total) * 100);
}

export function answeredCount(keys = [], answers = {}) {
  return keys.filter((key) => isAuditAnswerAnswered(answers[key])).length;
}

export function sectionAnsweredCount(items = [], answers = {}) {
  return items.filter((item) => isAuditAnswerAnswered(answers[item.key])).length;
}

export function sectionPercent(items = [], answers = {}) {
  return scorePercent(
    items.map((item) => item.key),
    answers
  );
}